import React from "react";

/**
 * ECLTextInput returns either an input or a label/input component for text.
 *
 * @export
 * @param {Object} props
 *    -name - string - provide a name to place a label above the input.
 *    -id - string - provide an ID to allow for lookup of value on form submission
 *    -placeholder - string - optional placeholder text
 *    -required - bool - is this a required input?
 *    -onChange - function - function that is bound to the inputs onChange function (so (e) => {...do stuff})
 *    -pattern - regex string - regex string to invalidate input
 *    -minLength - number - minimum number of characters for valid submission
 *    -maxLength - number - maximum number of characters for a valid submission
 *    -value - string - will appear as the default value
 * @return {ReactComponent}
 */
export default function ECLTextInput(props) {
   return props.name ? (
      <>
         <label data-testid="ecl-text-input-label" htmlFor={props.id}>
            {props.name}{" "}
            {props.required && <span className="required-input">*</span>}
         </label>
         <input
            className="ecl-input"
            id={props.id}
            type="text"
            name={props.name ? props.name : "text-input"}
            defaultValue={props.value}
            pattern={props.pattern}
            onChange={props.onChange}
            minLength={props.minLength}
            maxLength={props.maxLength}
            placeholder={props.placeholder ? props.placeholder : " "}
            required={props.required}
            list={props.list}
            autoComplete={"off"}
         />
      </>
   ) : (
      <>
         <input
            className="ecl-input"
            id={props.id}
            type="text"
            name={props.name ? props.name : "text-input"}
            defaultValue={props.value}
            pattern={props.pattern}
            onChange={props.onChange}
            minLength={props.minLength}
            maxLength={props.maxLength}
            placeholder={props.placeholder ? props.placeholder : " "}
            required={props.required}
            list={props.list}
            autoComplete={"off"}
         />
      </>
   );
}
